module.exports = "/_next/static/files/e47cf8e181ff79890534f085887135bd.png";